/* global */

import jwtDecode from 'jwt-decode'
import store from 'store'

export default {
  user: {
    authenticated: false
  },
  getPayload() {
    var jwt = store.get('id_token')

    if (jwt) {
      return jwtDecode(store.get('id_token'))
    } else {
      return null
    }
  },
  getTokenExpirationDate() {
    var decoded = this.getPayload()

    if (!decoded || !('exp' in decoded) || typeof decoded.exp === 'undefined') {
      return null
    }

    var d = new Date(0) // The 0 here is the key, which sets the date to the epoch
    d.setUTCSeconds(decoded.exp)

    return d
  },
  isTokenExpired(offsetSeconds) {
    var d = this.getTokenExpirationDate()
    offsetSeconds = offsetSeconds || 0
    if (d === null) {
      return false
    }

    // Token expired?
    return !(d.valueOf() > new Date().valueOf() + offsetSeconds * 1000)
  },
  login(token) {
    store.set('id_token', token)
    this.user.authenticated = true
  },
  logout() {
    store.remove('id_token')
    this.user.authenticated = false
  },
  checkAuth() {
    var jwt = store.get('id_token')
    if (jwt) {
      this.user.authenticated = true
    } else {
      this.user.authenticated = false
    }
  },
  getToken() {
    return store.get('id_token')
  },
  getAuthHeader() {
    return {
      Authorization: 'Bearer ' + store.get('id_token')
    }
  }
}
